const css = `@charset "UTF-8";
.exercises-header-options {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
}
@media (max-width: 576px) {
  .exercises-header-options {
    gap: 8px;
    /* Ajustar botones para dispositivos móviles */
  }
  .exercises-header-options > button,
  .exercises-header-options > div {
    margin-bottom: 8px;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL3BhZ2VzL0V4ZXJjaXNlcyIsInNvdXJjZXMiOlsiRXhlcmNpc2VzLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUdBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFORjtJQU9JO0FBRUE7O0VBQ0E7QUFBQTtJQUVFIiwic291cmNlc0NvbnRlbnQiOlsiLmVtcGxveWVlcy1wYWdlIHtcbn1cblxuLmV4ZXJjaXNlcy1oZWFkZXItb3B0aW9ucyB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtd3JhcDogd3JhcDtcbiAgZ2FwOiAxNnB4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuXG4gIEBtZWRpYSAobWF4LXdpZHRoOiA1NzZweCkge1xuICAgIGdhcDogOHB4O1xuXG4gICAgLyogQWp1c3RhciBib3RvbmVzIHBhcmEgZGlzcG9zaXRpdm9zIG3Ds3ZpbGVzICovXG4gICAgPiBidXR0b24sXG4gICAgPiBkaXYge1xuICAgICAgbWFyZ2luLWJvdHRvbTogOHB4O1xuICAgIH1cbiAgfVxufVxuIl19 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
